import ModalController from "./modal_controller";

export default class extends ModalController {
    hide() {
        super.hide();

        const video = this.modalContainerTarget.querySelector("iframe");
        video.setAttribute("src", video.getAttribute("src"));
    }
}